import List from './List';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'auto_generated_rates',
  inputShow: gql`
    query autoGeneratedRates($input: AutoGeneratedRateQueryInput) {
      autoGeneratedRates(input: $input) {
        id
        __typename
      }
    }
  `,
  list: List,
  show: Show,
  options: {
    group: 'Rates',
    label: 'Auto-Generated Rates Review',
    order: 6,
  },
};
